import angular from 'angular';
import sectionsLibraryService from './../../../SectionsLibraryService';
import toolbarService from './../../../../Toolbar/ToolbarService';
import mediaPlaceholder from './../../../../../MediaModules/MediaPlaceholder/MediaPlaceholder';
import ConfigParameter from "../../../../ConfigParameters/ConfigParameter";
import MapAddress from "../../../../ConfigParameters/ConfigParameters/MapAddress";
import MapApiKey from "../../../../ConfigParameters/ConfigParameters/MapApiKey";
import Paddings from "../../../../ConfigParameters/ConfigCollections/Paddings";
import Height from "../../../../ConfigParameters/ConfigParameters/Height";
import CustomClassName from "../../../../ConfigParameters/ConfigParameters/CustomClassName";

const MODULE_NAME = 'pageMap';

const creatorPageSectionMap = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: require('./map.html'),
    controller: function (ToolbarService, $element, $rootScope) {

        let defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = () => {
            this.elementModel = angular.copy(angular.extend(defaultConfig, this.elementModel));
            this.markLocation();
        };

        $rootScope.$on('map-changed', () => {
            this.markLocation();
        });

        this.markLocation = () => {
            //this console log is necessary for testing why maps are not working
            console.log(this.elementModel.address);
            let map = new google.maps.Map(
                $element.find('.map-container')[0],
                {
                    zoom: this.elementModel.address.zoom,
                    center: this.elementModel.address.coordinates,
                    disableDefaultUI: true,
                    draggable: false,
                }
            );
            let marker = new google.maps.Marker({position: this.elementModel.address.coordinates, map: map});
        };
    }

};

export default angular.module('cms.creator.page.section-map', [sectionsLibraryService, toolbarService, mediaPlaceholder])
    .run(function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator) {

        SectionsLibraryService.registerSection({
            icon: 'map',
            type: MODULE_NAME,
            label: gettext('Map'),
            group: 'page',
            groups: {
                mainConfig: {
                    label: gettext('Main config'),
                    isOpen: true,
                    type: 'mainConfig'
                },
                position: {
                    label: gettext('Position'),
                    isOpen: false,
                    type: 'position'
                },
                advanced: {
                    label: gettext('Advanced'),
                    isOpen: false,
                    type: 'advanced'
                }
            }
        });

        ToolbarService.registerSectionSchema(MODULE_NAME, {
            ...(new ConfigParameter('sectionId', 'hidden', gettext('Section Id'), null, (type) => UniqueIdGenerator.generate(type))),
            ...(new ConfigParameter('uid', 'hidden', '', null, () => UniqueIdGenerator.generate('element-uid'))),
            ...(new MapAddress()),
            ...(new MapApiKey()),
            ...(new Paddings()),
            ...(new Height()),
            ...(new CustomClassName())
        });

    })
    .component('cmsCreatorPageSectionMap', creatorPageSectionMap).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Page/Map/Map.js